import { render, staticRenderFns } from "./ChatbotBubble.vue?vue&type=template&id=038dad64&"
import script from "./ChatbotBubble.vue?vue&type=script&lang=js&"
export * from "./ChatbotBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports